<template>
	<div class="tipspopbox_bg" v-show="unlock">
		<div class="tipspopbox">
			<span class="closebtn" @click="unlock=false"></span>
			<div class="permissionRestrictions">
				<h5 class="title">温馨提示</h5>
				<p v-show="type == 'permissionNum'">您的当前解锁次数已使用完毕</br>查看更多详细信息，请联系我们，<b>升级为正式账号</b>。</p>
				<p v-show="type == 'permission'">您使用的是试用账号，访问权限有限</br>要解锁更多使用权限，请联系我们，<b>申请升级为正式账号</b>。</p>
				<p>服务电话：<br /><b>0755-82571568</b><b>13828848318</b></p>
				<div class="basebtn" @click="unlock=false">我知道了</div>
			</div>
		</div>
		<!-- <div class="enprise_lockbox"> 
			<p class="redtips onetip" v-html="tipstext"></p>   
			<span class="closebtn" @click="unlock=false"></span>
		</div> -->
	</div>
</template>

<script>
	export default {
		name: 'tipspop',
		data() {
			return {
				unlock: false,
				tipstext: '加载中',
				type: 'permission',
			}
		},
		created() {
			var that = this;
			this.bus.$on('tipspop', function(data) {
				that.unlock = data.lock;
				that.type = data.type;
				// that.tipstext=data.text;

			})
		},
		methods: {
			tipspopFun(data) {
				// var data={lock:true,type:"permission"};
				this.unlock = data.lock;
				this.type = data.type;
			}
		},
		mounted() {
			window.tipspopFun = this.tipspopFun;
		}
	}
</script>

<style>
</style>